// ─── Knowledge Base API client ──────────────────────────────────────────────
// Lightweight wrapper over the /api/dashboard/knowledge-base/ endpoints
// added on the server side. List returns the small-payload shape (no body);
// retrieve returns the full article including its HTML body, and bumps a
// server-side view counter as a side effect.
//
// All endpoints require an authenticated user. The frontend widget treats
// any 4xx/5xx as "API unavailable" and falls back to a hardcoded demo list
// so the dashboard remains usable when the backend is being restarted or
// the migration hasn't run yet.

import axios from 'axios'

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:8000'
const API_BASE_PATH = import.meta.env.VITE_API_BASE_PATH || '/api'
const API_BASE_URL = `${API_URL}${API_BASE_PATH}/dashboard/knowledge-base`
const JWT_STORAGE_KEY = import.meta.env.VITE_JWT_STORAGE_KEY || 'auth_token'

const apiClient = axios.create()
apiClient.interceptors.request.use((config) => {
  const token = (localStorage.getItem(JWT_STORAGE_KEY) || sessionStorage.getItem(JWT_STORAGE_KEY))
  if (token) config.headers.Authorization = `Bearer ${token}`
  return config
})

export const kbApi = {
  // GET /api/dashboard/knowledge-base/ — list of active articles. The
  // server omits the body field on list responses so the payload stays
  // small even with hundreds of articles.
  listArticles: (search) => apiClient.get(`${API_BASE_URL}/`, {
    params: search ? { search } : {},
  }),

  // GET /api/dashboard/knowledge-base/<id>/ — full article including HTML
  // body. Triggers a server-side view_count increment.
  getArticle: (id) => apiClient.get(`${API_BASE_URL}/${id}/`),
}

export default kbApi
